export const APP_NAME = 'PanelVue'
export const BACKEND_PORT = 8093
export const BACKEND_URL = `https://mobile.pbvue.com:${BACKEND_PORT}/api`

export default {
    APP_NAME,
    BACKEND_PORT,
    BACKEND_URL,
}